/**
 * @file Automatically generated by barrelsby.
 */

export * from './formly-addons.extension';
export * from './formly-data-cy.extension';
export * from './formly-translate.extension';
